import { apiClient } from './api/apiClient';
import type { RegionTree } from '../types/region';

/**
 * 組織階層サービス
 * Region（大地区）→ SubRegion（JA）→ Area（地区）の地理マスタツリーを取得する
 */
class RegionService {
  /**
   * 地理マスタツリー（Region → SubRegion → Area, id + name）を一括取得する
   * @returns 大地区ツリーの配列
   */
  async getRegionTree(): Promise<RegionTree[]> {
    return apiClient.get<RegionTree[]>('/regions/tree');
  }
}

/** 組織階層サービスのシングルトンインスタンス */
export const regionService = new RegionService();
